module.exports = __webpack_public_path__ + "img/cp.7d90c4e9.svg";